/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowIceSkatingTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowIceSkating,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Hit the Ice!",
    "Skate the Day Away!",
    "Ice Skating Fun!",
  ],
  title: "Ice Skating Outing",
  description: "Organize a fun ice skating outing.",
  longDescription:
    "Gather your friends for a day of ice skating! Choose a date, select an ice rink, and plan on where to eat afterward!",
  emoji: "⛸",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Ice Skating Outing",
          emoji: "⛸",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go ice skating?",
          emoji: "📅",
          completeAction: {
            question: "Decide on an ice rink?",
            description: "Which ice rink should we skate at?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What ice rink should we choose?",
                emoji: "🏒",
                completeAction: {
                  question: "Decide on where to eat afterward?",
                  description: "Where should we grab a bite after skating?",
                  addModules: [
                    {
                      type: ModuleType.Location,
                      doneType: ModuleDoneType.Voting,
                      title: "Where should we eat?",
                      emoji: "🍔",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Glide on Ice!",
    outroDescription:
      "Your ice skating plans are set! Enjoy the fun on the ice!",
  },
};
